import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AjaxService, UtilityService } from 'src/app/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'app-iylon-products',
  templateUrl: './iylon-products.component.html',
  styleUrls: ['./iylon-products.component.less']
})
export class IylonProductsComponent implements OnInit {
  viewportMetaTag!: HTMLMetaElement;
  constructor(
    private _commonDataService: CommonDataService,
    private _ajaxService: AjaxService,
    private _utilityService: UtilityService,
    private _route: Router,
    private _activated_route: ActivatedRoute,
    private renderer: Renderer2
  ) { }

  onDestroy$ = new Subject<void>();
  IylonProducts: any = [];
  affiliateId: undefined;
  paymentData: any;
  token:any;

  ngOnInit(): void {
     // Create and add the viewport meta tag for this page only
     this.viewportMetaTag = this.renderer.createElement('meta');
     this.viewportMetaTag.name = 'viewport';
     this.viewportMetaTag.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
     this.renderer.appendChild(document.head, this.viewportMetaTag);

    this._activated_route.params.subscribe(params => {
      this.paymentData = (params && params.paymentData) ? JSON.parse(atob(params.paymentData)) : undefined;
      this.affiliateId=this.paymentData.affiliateId;
      this.token=this.paymentData.token;
    });
    this.getAllIylonProducts();

  }
  ngOnDestroy(): void {
    // Remove the viewport meta tag to avoid affecting other pages
    if (this.viewportMetaTag) {
      this.renderer.removeChild(document.head, this.viewportMetaTag);
    }
  }
  async getAllIylonProducts() {
    let req = {
      AffiliateId: this.affiliateId
    }
    await this._ajaxService.post('/iylonProducts/getAll', req,{ headers: { authorization: 'Bearer ' + this.token }}).subscribe(async response => {
      if (response.success) {
        this.IylonProducts = response.data;
        console.log(this.IylonProducts)
      } else {
        this._utilityService.showError(response.error);
      }
    });

  }
  pay(amount: any, productName: any,productId:any) {
    if (window.location.host.includes('app.iylon.com')) {
      this.paymentData['isProd'] = true;
    } else {
      this.paymentData['isProd'] = false;
    }
    console.log(this.paymentData);
    this.paymentData['productDetails'] = {
      "amountToPay": amount,
      "optedProduct": productName,
      "productId":productId
    }
    let reqObj = {
      amount: amount * 100,//Converting cent to Dollar
      caseId: this.paymentData.CaseId,
      isProd: this.paymentData.isProd,
      productId: productId
    }
    this._ajaxService.post('/miscellaneous/payment', reqObj).subscribe((response) => {
      if(response.useStripePaymentGateway){
        this.paymentData['stripeData'] = response.paymentIntent;
        this._route.navigate(["/payment-Page/", btoa(unescape(encodeURIComponent(JSON.stringify(this.paymentData))))]);
      }else{
        if (!window.location.host.includes('app.iylon.com')) {
          alert('We have noticed you are in test mode. Please use below credit card detials.\nCard Number: 4012888888881881\nExpiry Date: Any future date\nCVV: Any 3 digit number\nName: Your name');
        } 
        window.location=response.forwardLink;
      }
    }) 
  }

  // pay(amount: any, productName: any,productId:any) {
  //   if (window.location.host.includes('app.iylon.com')) {
  //     this.paymentData['isProd'] = true;
  //   } else {
  //     this.paymentData['isProd'] = false;
  //   }
  //   console.log(this.paymentData);
  //   this.paymentData['productDetails'] = {
  //     "amountToPay": amount,
  //     "optedProduct": productName,
  //     "productId": productId
  //   }
  //   let reqObj = {
  //     amount: amount * 100,//Converting cent to Dollar
  //     caseId: this.paymentData.caseId,
  //     isProd: this.paymentData.isProd,
  //     productId: productId
  //   }
  //   this._ajaxService.post('/miscellaneous/payment', reqObj,{ headers: { authorization: 'Bearer ' + this.token }}).subscribe((response) => {
  //     this.paymentData['stripeData'] = response.paymentIntent;
  //     this._route.navigate(["/payment-Page/", btoa(JSON.stringify(this.paymentData))]);
  //   })
  // }

}
